import angular from "angular";
import directive from "./loading.directive";

export default angular
  .module("admin.directives.loading", [])
  .directive("loading", directive);
